const prefix = 'FEATURE_ACCESS/'

const actionTypes = {
  // Replace the entire feature access list with a new array
  SET_FEATURE_LIST: `${prefix}SET_FEATURE_LIST`,

  // Upsert a single feature by featureCode
  UPSERT_FEATURE: `${prefix}UPSERT_FEATURE`,
}

export default actionTypes
